<template>
	<b-container id="sidebarEmpty" class="no-gutters p-0"><!-- @click="$emit('ToggleSidebarCollapsedEvent')" -->
		<b-row align-h="center" class="justify-content-center">
			<!-- Bouton de recherche de patrimoine -->
			<b-col class="border text-center">
				<b-button v-b-tooltip.hover :title="$t('HeritageSearch')" @click.stop="searchVisible = true" :pressed="searchVisible" variant="outline-dark"
					class="btn-circle p-0 border-0 text-center">
					<b-icon icon="search" />
				</b-button>

				<!-- Bouton de recherche de noeuds -->
				<Search v-if="searchVisible" :UseGrouping="true" :Visible.sync="searchVisible" :Variant="Variant" :FilterTreeStore="MAIN_FILTER_TREE" />
			</b-col>

			<!-- Bouton pour déplier la sidebar  -->
			<b-col class="pl-2 pb-2">
				<b-button @click="$emit('ToggleSidebarCollapsedEvent')" variant="light" size="sm" pill class="pullButton">
					<b-icon icon="chevron-right"/>
				</b-button>
			</b-col>
		</b-row>
	</b-container>
</template>

<script lang="ts">
	import Component from 'vue-class-component';
	import { Vue, InjectReactive } from 'vue-property-decorator';
	import Search from "@/components/commons/Search.vue";
	import { MAIN_FILTER_TREE } from '@/App.settings';

	/** Sidebar vide (lorsque FullSidebar est replié) */
	@Component({
		components: {
			Search
		}
	})
	export default class EmptySidebar extends Vue {
		/** Variant de couleur à appliquer sur le composant */
		@InjectReactive()
		public Variant!: string;

		/** Détermine si la modal de recherche s'affiche ou non*/
		private searchVisible: boolean = false;
	}
</script>

<style scoped>
	/** Bouton de réctraction de la sidebar */
	.pullButton {
		/* background: #212121;
		text-align: center; */
		padding: 6px 0px;
		width: 40px;
		position: absolute !important; 
		/* change this */ 
		transform: translate(50%, 50%);
		z-index: 1000 !important;
		/* and this */
		right:0%;
		top:2rem;
	}

	#sidebarEmpty {
		box-sizing: border-box;
		position: static;
		display: inline-block;
		margin: 0px 0px;
		z-index: 6;
		height: 100%;
	}
</style>